import type { MemberCode, PreferredOwnershipConfig } from '@/types/waterfall'
import { MEMBERS } from '@/types/waterfall'

export type PreferredOwnershipRow = { date: string; member: MemberCode; share: string }

function formatShareField(value: number | string): string {
  const num = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(num)) return ''
  return String(num)
}

function parseShare(share: string): number | null {
  const trimmed = share.trim()
  if (!trimmed) return null
  const num = Number(trimmed)
  if (!Number.isFinite(num) || num < 0 || num > 1) return null
  return num
}

export function preferredOwnershipFromConfig(value: unknown): PreferredOwnershipRow[] {
  if (!value || typeof value !== 'object') return []
  const rows: PreferredOwnershipRow[] = []
  for (const [date, byMember] of Object.entries(value as Record<string, unknown>)) {
    if (!byMember || typeof byMember !== 'object') continue
    for (const [member, share] of Object.entries(byMember as Record<string, unknown>)) {
      if (!MEMBERS.includes(member as MemberCode)) continue
      if (share === null || share === undefined) continue
      const shareStr = formatShareField(share as number | string)
      if (!shareStr) continue
      rows.push({ date, member: member as MemberCode, share: shareStr })
    }
  }
  return rows.sort(
    (a, b) => a.date.localeCompare(b.date) || a.member.localeCompare(b.member),
  )
}

export function preferredOwnershipToConfig(rows: PreferredOwnershipRow[]): PreferredOwnershipConfig {
  const out: PreferredOwnershipConfig = {}
  for (const row of rows) {
    if (!row.date) continue
    const parsed = parseShare(row.share)
    if (parsed == null) continue
    if (!out[row.date]) out[row.date] = {}
    out[row.date]![row.member] = parsed
  }
  return out
}
